import * as types from '../types'


const initialState = {
  image: {},
  image_property: [],
  showLoading: false,
}

export const appReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {
    case types.GET_IMAGE_WITH_PROPERTY:
      return {
        ...state,
        image: action.payload,
        image_property: action.payload.image_properties
      }
    case types.ADD_IMAGE_PROPERTY:
      return {
        ...state,
        image_property: [...state.image_property, action.payload]
      }
    case types.REMOVE_IMAGE_PROPERTY:
      const currentItem = state.image_property.slice().filter((x) => x.property_id !== action.payload);
      console.log(currentItem)
      return {
        ...state,
        image_property: currentItem,
      }
    case types.TOGGLE_LOADING:
      return {
        ...state,
        showLoading: action.payload,
      }
    case types.UPDATE_PROPERTY_TEXT:
      let teProperty = state.image_property.slice();
      const te_index = teProperty.findIndex((x) => x.property_id === action.payload.id)
      const teValue = teProperty[te_index]
      teValue.text_label = action.payload.text_label;
      return {
        ...state,
        image_property: teProperty
      }
    case types.UPDATE_TEXTAREA_SIZE:
      let sProperty = state.image_property.slice();
      const sindex = sProperty.findIndex((x) => x.property_id === action.payload.id)
      const sValue = sProperty[sindex]

      sValue.width = action.payload.text_area_width + 'px';
      sValue.height = action.payload.text_area_hieght + 'px';

      return {
        ...state,
        image_property: sProperty
      }
    case types.UPDATE_IMAGE_SIZE:
      let sImgProperty = state.image_property.slice();
      const sImagIndex = sImgProperty.findIndex((x) => x.property_id === action.payload.id)
      const sImdValue = sImgProperty[sImagIndex]

      sImdValue.width = action.payload.text_area_width + 'px';
      // sImdValue.height = action.payload.text_area_height+'px';
      return {
        ...state,
        image_property: sImgProperty,
        isImageUpdate: true
      }
    case types.UPDATE_PHOTO_HOLDER_SIZE:
      let phProperty = state.image_property.slice();
      const phImagIndex = phProperty.findIndex((x) => x.property_id === action.payload.id)
      const phValue = phProperty[phImagIndex]

      phValue.width = action.payload.photo_holder_width + 'px';
      phValue.height = action.payload.photo_holder_height + 'px';
      return {
        ...state,
        image_property: phProperty,
        isImageUpdate: true
      }
    case types.UPDATE_FONT_FAMILY:
      let fProperty = state.image_property.slice();
      const index = fProperty.findIndex((x) => x.property_id === action.payload.id)
      const value = fProperty[index]
      value.font_family = action.payload.font_family
      value.font_weight = action.payload.font_weight
      return {
        ...state,
        image_property: fProperty
      }
    case types.UPDATE_FONT_SIZE:
      let FProperty = state.image_property.slice();
      const fIndex = FProperty.findIndex((x) => x.property_id === action.payload.id)
      const fValue = FProperty[fIndex]
      fValue.font_size = action.payload.font_size
      fValue.line_height = action.payload.line_height

      return {
        ...state,
        image_property: FProperty
      }
    case types.UPDATE_LINE_HEIGHT:
      let ltProperty = state.image_property.slice();
      const ltIndex = ltProperty.findIndex((x) => x.property_id === action.payload.id)
      const ltValue = ltProperty[ltIndex]
      ltValue.line_height = action.payload.line_height

      return {
        ...state,
        image_property: ltProperty
      }

    case types.UPDATE_FONT_COLOR:
      let CProperty = state.image_property.slice();
      const cIndex = CProperty.findIndex((x) => x.property_id === action.payload.id);
      const cValue = CProperty[cIndex]
      cValue.color = action.payload.color
      return {
        ...state,
        image_property: CProperty
      }

    case types.UPDATE_BACKGROUND_COLOR:
      let bgProperty = state.image_property.slice();
      const bgIndex = bgProperty.findIndex((x) => x.property_id === action.payload.id);
      const bgValue = bgProperty[bgIndex]
      bgValue.background_color = action.payload.background_color
      return {
        ...state,
        image_property: bgProperty
      }
    case types.UPDATE_BOX_ROTATION:
      let brProperty = state.image_property.slice();
      const brIndex = brProperty.findIndex((x) => x.property_id === action.payload.id);
      const brValue = brProperty[brIndex]
      brValue.rotate_box = action.payload.rotate_box
      return {
        ...state,
        image_property: brProperty
      }
    case types.UPDATE_TEXT_STROKE:
      let tsProperty = state.image_property.slice();
      const tsIndex = tsProperty.findIndex((x) => x.property_id === action.payload.id);
      const tsValue = tsProperty[tsIndex]
      tsValue.text_stroke = action.payload.text_stroke
      return {
        ...state,
        image_property: tsProperty
      }
    case types.UPDATE_LETTER_SPACING:
      let LProperty = state.image_property.slice();
      const lIndex = LProperty.findIndex((x) => x.property_id === action.payload.id);
      const lValue = LProperty[lIndex]
      lValue.letter_spacing = action.payload.letter_spacing
      return {
        ...state,
        image_property: LProperty
      }
    case types.UPDATE_TEXT_ALIGNMENT:
      let AProperty = state.image_property.slice();
      const aIndex = AProperty.findIndex((x) => x.property_id === action.payload.id);
      const aValue = AProperty[aIndex]
      aValue.text_alignment = action.payload.text_alignment
      return {
        ...state,
        image_property: AProperty
      }
    case types.UPDATE_PROPERTY_TRANSLATION:
      let tProperty = state.image_property.slice();
      const tIndex = tProperty.findIndex((x) => x.property_id === action.payload.id);
      const tValue = tProperty[tIndex]
      tValue.translate_option.position_x = action.payload.position_x
      tValue.translate_option.position_y = action.payload.position_y
      return {
        ...state,
        image_property: tProperty
      }

    case types.UPDATE_PHOTO:
      let allProperty = state.image_property.slice();
      const phIndex = allProperty.findIndex((x) => x.property_id === action.payload.id);
      const photoValue = allProperty[phIndex]
      photoValue.image_url = action.payload.photo_url
      return {
        ...state,
        image_property: allProperty
      }

      case types.REMOVE_PHOTO:
        let rpProperty = state.image_property.slice();
        const rpIndex = rpProperty.findIndex((x) => x.property_id === action.payload.id);
        const rpValue = rpProperty[rpIndex]
        rpValue.image_url = null
        return {
          ...state,
          image_property: rpProperty
        }
  
      
    default:
      return state;
  }
};
